import PropTypes from 'prop-types';
import React from 'react';
import BaseComponent from 'apps/new-web/views/component';

export default class FacebookLoginWrapper extends BaseComponent {
  static get propTypes() {
    return {
      appId: PropTypes.string.isRequired,
      children: PropTypes.object.isRequired,
      onAccessToken: PropTypes.func.isRequired
    };
  }

  getFacebookAccessToken() {
    this.getFacebookSDK((err, FB) => {
      if (err) return;

      var previousAuthResponse = FB.getAuthResponse();
      if (previousAuthResponse) {
        return this.props.onAccessToken(previousAuthResponse.accessToken);
      }

      FB.login(loginResponse => {
        if (!loginResponse.authResponse) return;

        this.props.onAccessToken(loginResponse.authResponse.accessToken);
      });
    });
  }

  getFacebookSDK(cb) {
    if (window.FB) return cb(null, window.FB);

    let appId = this.props.appId;

    window.fbAsyncInit = function() {
      window.FB.init({
        appId: appId,
        xfbml: true,
        version: 'v2.7'
      });
      cb(null, window.FB);
    };

    (function(d, s, id){
       var js, fjs = d.getElementsByTagName(s)[0];
       if (d.getElementById(id)) {return;}
       js = d.createElement(s); js.id = id;
       js.src = '//connect.facebook.net/en_US/sdk.js';
       fjs.parentNode.insertBefore(js, fjs);
     })(document, 'script', 'facebook-jssdk');
  }

  render() {
    return React.cloneElement(this.props.children, {
      onClick: this.getFacebookAccessToken
    });
  }
}
